import * as React from "react";
import styled from "styled-components";
import { StaticImage } from "gatsby-plugin-image";
import { FaArrowRight } from "react-icons/fa";
import LeadBoxesScript from "../../components/lead-boxes-script"

const StyledContainer = styled("div")`
  background-color: whitesmoke;

  .heropic {
    max-width: 100%;
    object-fit: contain;
  }

  .row {
    text-align: left;
  }

  .container-width {
    max-width: 90%;
  }

  .lists {
    padding-left: 15px;
  }

  ul > li {
    padding-bottom: 20px;
    letter-spacing: 0.2px;
  }

  .btn:hover > a {
    color: #fff !important;
  }

  @media (max-width: 768px) {
    .heropic {
      margin-top: 30px;
    }
    .col-md-6 {
      margin-bottom: 30px;
    }
  }
`;

const ApiForDevelopers = () => {
  return (
    <StyledContainer className="container-fluid d-flex justify-content-center all">
      <div className="container pt-3 ">
        <h2 className="text-center fw-bold">API For Developers</h2>
        <div className="row justify-content-center main-container">
          <div className="col-md-6 col-sm-12 px-3 pt-4">
            <h3 className="py-3 fw-bold">
              Automate Workflow Using Powerful, Easy-to-use APIs
            </h3>
            <p>
              <b>Clearout's REST API</b> can be integrated with any programming
              language thus saving engineers time. Developers can easily
              integrate <b>real-time email validation</b> throughout all email
              capture points of contact, and also <b>discover and enrich email addresses</b> of existing and new
              leads.
              <br />
              <br />
              If you need to perform millions of email verification and finding
              on a large scale, use our bulk APIs.
            </p>
            <div className="align-center">
              <button type="button" className="btn btn-outline-dark">
                <a
                  href="https://docs.clearout.io/api-overview.html"
                  target="_blank"
                  rel="noreferrer"
                  aria-label="Explore api"
                >
                  Explore <FaArrowRight />
                </a>
              </button>
            </div>
          </div>
          <div className="col-md-6 col-sm-12 text-end">
            <StaticImage
              src="../../images/clearout-api-screen.png"
              alt="Clearout's REST API for finding and verifying email addresses"
              layout="fullWidth"
              placeholder="blurred"
            />
          </div>
        </div>
      </div>
      <LeadBoxesScript id={"sqViXaCaxZsxzTbkSBBuj5"} />
    </StyledContainer>
  );
};

export default ApiForDevelopers;
